import { Box, IconButton } from "@material-ui/core";
import { QuoteDeduction } from "../../api/Quote/QuoteDeduction";
import CloseIcon from "@material-ui/icons/Close";
import { EQuoteDeductionStatus } from "../../api/Quote/EQuoteDeductionStatus";
import { TF } from "../typography/TF";
import { EQuoteDeductionCategory } from "../../api/Quote/EQuoteDeductionCategory";

interface Props {
  deduction: QuoteDeduction;
  onDelete: (quoteDeductionId: string) => void;
}

export const DeductionLine = ({ deduction, onDelete }: Props) => {
  const handleDelete = async () => {
    onDelete(deduction.id);
  };

  const status = (status: EQuoteDeductionStatus) => {
    switch (status) {
      case EQuoteDeductionStatus.Expired:
        return "Expired";
      case EQuoteDeductionStatus.NotActive:
        return "Not applicable";
      case EQuoteDeductionStatus.Removed:
        return "Not applicable";
    }
  };

  if (deduction.status === EQuoteDeductionStatus.Removed) {
    return <></>;
  }

  const statusSection = deduction.status !== EQuoteDeductionStatus.Applied && (
    <TF component="span" color="storeRed">
      {status(deduction.status)}
    </TF>
  );

  const valueSection = deduction.status === EQuoteDeductionStatus.Applied && (
    <TF variant="body2" color="storeRed" component="span">
      -&nbsp;
      <TF variant="body2" format="price" component="span">
        {deduction.discountValue}
      </TF>
    </TF>
  );

  const removeSection = (deduction.category === EQuoteDeductionCategory.Promotion ||
    deduction.category === EQuoteDeductionCategory.Referral) && (
    <IconButton onClick={handleDelete}>
      <CloseIcon fontSize="small" />
    </IconButton>
  );

  return (
    <>
      <Box alignItems="center" display="flex">
        <Box textAlign="left" flexGrow={1}>
          <TF variant="body2" color="storeRed">
            Discount {deduction.promoCode && <>({deduction.promoCode})</>}
          </TF>
        </Box>
        <Box
          pr={
            deduction.category === EQuoteDeductionCategory.Promotion ||
            deduction.category === EQuoteDeductionCategory.Referral
              ? 1
              : 6.5
          }
        >
          {valueSection}
          {statusSection}
          {removeSection}
        </Box>
      </Box>
    </>
  );
};
